import React, { useState, useRef } from "react";
import { Box, Container, useMediaQuery, useTheme } from "@mui/material";
import { MediaPlayer, MediaProvider, Poster } from "@vidstack/react";
import {
  defaultLayoutIcons,
  DefaultVideoLayout,
} from "@vidstack/react/player/layouts/default";
import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/video.css";
import PlayCircleOutlineRoundedIcon from "@mui/icons-material/PlayCircleOutlineRounded";
const VITE_VISUALIZE__URL = import.meta.env.VITE_VISUALIZE__URL;

const WomensHealthDemo: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const playerRef = useRef<any>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  // Function to handle video playback
  const handlePlay = () => {
    if (playerRef.current) {
      playerRef.current.play();
      setIsPlaying(true);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#fff",
        position: "relative",
        overflow: "hidden",
        padding: "50px 0px",
      }}
    >
      {/* Logo */}
      <Box
        sx={{
          position: "absolute",
          top: 20,
          left: 20,
          zIndex: 1,
          width: isMobile ? 120 : 150,
          height: "auto",
        }}
      >
        <img
          src={`${VITE_VISUALIZE__URL}Clinical_Visuals_Logo.webp`}
          alt="Clinical Visuals Logo"
          style={{ width: "100%", height: "auto" }}
        />
      </Box>

      {/* Video Player Container */}
      <Container
        maxWidth={false}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          pt: isMobile ? 8 : 1,
          px: isMobile ? 2 : 1,
          position: "relative",
          zIndex: 0,
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            maxWidth: isMobile ? "100%" : isTablet ? "90%" : "80%",
            maxHeight: "90vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: "100%",
              position: "relative",
              "& .vds-media-player": {
                width: "100%",
                height: "100%",
              },
              "& .vds-video": {
                width: "100%",
                height: "100%",
                objectFit: "contain",
              },
            }}
          >
            <MediaPlayer
              title="Women's Health Demo Video"
              src={`${VITE_VISUALIZE__URL}Gynac.webm`}
              aspectRatio="16/9"
              controls={false}
              autoplay={false}
              muted={false}
              loop={false}
              playsinline
              poster={`${VITE_VISUALIZE__URL}Clinical_Visuals_ENT_Demo_poster.webp`}
              ref={playerRef}
              onPlay={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
              onLoadedMetadata={() => {
                if (playerRef.current?.el?.loop !== undefined) {
                  playerRef.current.el.loop = false;
                }
              }}
            >
              <MediaProvider>
                <Poster className="vds-poster" />
              </MediaProvider>
              <DefaultVideoLayout icons={defaultLayoutIcons} />
            </MediaPlayer>

            {/* Play Icon Overlay */}
            {!isPlaying && !isMobile && (
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 2,
                  cursor: "pointer",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  padding: "2px",
                  borderRadius: "15%",
                }}
                onClick={handlePlay}
              >
                <PlayCircleOutlineRoundedIcon
                  sx={{
                    color: "#fff",
                    marginTop: "4px",
                    fontSize: "40px",
                    width: "50px",
                    height: "40px",
                  }}
                />
              </Box>
            )}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default WomensHealthDemo;
